import { flow } from '@hcr/utils'

import { createCouponValidity } from './createCouponValidity'

export const createCouponValidityString = flow(createCouponValidity, ({ date, label }) => `${label} ${date}`)
